<template>
  <v-app-bar id="app-bar" absolute app color="primary" elevation="5" flat height="65">
    <v-icon color="white"  class="mr-3 font-size-18" @click="setDrawer(!drawer)"> mdi-menu </v-icon>
    <img src="/img/logo.png" width="40px" alt="" class="mr-5" />
    <h4 class=" mr-2 white--text "> Tebyan Smart CRM</h4>
<!--    <v-btn class="mr-3" color="transition" elevation="0" fab small @click="setDrawer(!drawer)">-->
<!--      <v-icon v-if="value"> mdi-view-quilt </v-icon>-->

<!--      <v-icon color="white"  class="font-size" v-else> mdi-menu </v-icon>-->
<!--    </v-btn>-->

    <!--    <v-toolbar-title-->
    <!--      class="hidden-sm-and-down font-weight-light"-->
    <!--      v-text="$route.name"-->
    <!--    />-->

    <v-spacer />

    <!--    <v-text-field-->
    <!--      :label="$t('search')"-->
    <!--      color="secondary"-->
    <!--      hide-details-->
    <!--      style="max-width: 165px;"-->
    <!--    >-->
    <!--      <template-->
    <!--        v-if="$vuetify.breakpoint.mdAndUp"-->
    <!--        v-slot:append-outer-->
    <!--      >-->
    <!--        <v-btn-->
    <!--          class="mt-n2"-->
    <!--          elevation="1"-->
    <!--          fab-->
    <!--          small-->
    <!--        >-->
    <!--          <v-icon>mdi-magnify</v-icon>-->
    <!--        </v-btn>-->
    <!--      </template>-->
    <!--    </v-text-field>-->

    <div class="mx-3" />

<!--    <v-btn class="ml-2" min-width="0" text to="/">-->
<!--      <v-icon>mdi-view-dashboard</v-icon>-->
<!--    </v-btn>-->

<!--    <v-menu-->
<!--      bottom-->
<!--      left-->
<!--      offset-y-->
<!--      origin="top right"-->
<!--      transition="scale-transition"-->
<!--    >-->
<!--      <template v-slot:activator="{ attrs, on }">-->
<!--        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">-->
<!--          &lt;!&ndash;          <v-badge&ndash;&gt;-->
<!--          &lt;!&ndash;            color="red"&ndash;&gt;-->
<!--          &lt;!&ndash;            overlap&ndash;&gt;-->
<!--          &lt;!&ndash;            bordered&ndash;&gt;-->
<!--          &lt;!&ndash;          >&ndash;&gt;-->
<!--          &lt;!&ndash;&lt;!&ndash;            <template v-slot:badge>&ndash;&gt;&ndash;&gt;-->
<!--          &lt;!&ndash;&lt;!&ndash;              <span>5</span>&ndash;&gt;&ndash;&gt;-->
<!--          &lt;!&ndash;&lt;!&ndash;            </template>&ndash;&gt;&ndash;&gt;-->

<!--          &lt;!&ndash;            <v-icon>mdi-bell</v-icon>&ndash;&gt;-->
<!--          &lt;!&ndash;          </v-badge>&ndash;&gt;-->
<!--          <v-icon>mdi-bell</v-icon>-->
<!--        </v-btn>-->
<!--      </template>-->

<!--      &lt;!&ndash;      <v-list&ndash;&gt;-->
<!--      &lt;!&ndash;        :tile="false"&ndash;&gt;-->
<!--      &lt;!&ndash;        nav&ndash;&gt;-->
<!--      &lt;!&ndash;      >&ndash;&gt;-->
<!--      &lt;!&ndash;        <div>&ndash;&gt;-->
<!--      &lt;!&ndash;          <app-bar-item&ndash;&gt;-->
<!--      &lt;!&ndash;            v-for="(n, i) in notifications"&ndash;&gt;-->
<!--      &lt;!&ndash;            :key="`item-${i}`"&ndash;&gt;-->
<!--      &lt;!&ndash;          >&ndash;&gt;-->
<!--      &lt;!&ndash;            <v-list-item-title v-text="n" />&ndash;&gt;-->
<!--      &lt;!&ndash;          </app-bar-item>&ndash;&gt;-->
<!--      &lt;!&ndash;        </div>&ndash;&gt;-->
<!--      &lt;!&ndash;      </v-list>&ndash;&gt;-->
<!--    </v-menu>-->

<!--    <v-tooltip bottom >-->
<!--      <template v-slot:activator="{ on }">-->
<!--        <v-icon-->
<!--          v-on="on" small color="white"-->
<!--          @click="logout" >-->
<!--          mdi-power-->
<!--        </v-icon>-->
<!--      </template>-->
<!--      <span>خروج</span>-->
<!--    </v-tooltip>-->
    <v-btn class="ml-2" min-width="0" text @click="logout">
      <v-icon color="white">mdi-power</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({

  }),

  computed: {
    ...mapState(["drawer"]),
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    logout() {
      this.$store.dispatch("auth/logout")
    },
  },
};
</script>
<style>
.font-size-18{
  font-size: 18px !important;
}
</style>
